import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { ILoginInfo } from "../interface/IAccount";
import { InvitationSendParamModel } from "../model/account";
import { LoginParamModel } from "../model/login";
import InvitationService from "../service/InvitationService";

import LoginService from "../service/LoginService";
import { RootState } from "../store/store";
import { logoutUser } from "./common";

type SliceState = { value: ILoginInfo; status: string };
const initialState = {
  value: {},
  status: COMMON_STATUS.LOGOUT,
} as SliceState;

export const resetLogout = createAction("login/reset");

const _service = new LoginService();

const _serviceInvi = new InvitationService();

export const loginAsync = createAsyncThunk(
  "login/loginApi",
  async (params: LoginParamModel) => {
    const response = await _service.loginService(params);
    return response;
  }
);

export const invitationSendAsync = createAsyncThunk(
  "login/sendInvitation",
  async (params: InvitationSendParamModel) => {
    const response = await _serviceInvi.invitationSendService(params);
    return response;
  }
);

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    updateListView: (state, action) => {
      state.value.listView = action.payload;
    },
    updateLoginStatus: (state, action) => {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(loginAsync.fulfilled, (state: SliceState, action: any) => {
        if (action.payload.canLogin==false) {
          state.value = {
            firstName: undefined,
            lastName: undefined,
            token: undefined,
            userId: undefined,
            userName: undefined,
            roles: [],
            errorMessage :action.payload.errorMessage
          };
          state.status = COMMON_STATUS.ERROR;
        } else if (
          action.payload.userName.toLocaleLowerCase().trim() ===
            action.meta.arg.username.toLocaleLowerCase().trim() &&
          action.payload.token
        ) {
          state.value = action.payload;
          state.status = COMMON_STATUS.LOGIN;
        } else {
          state.value = {
            firstName: undefined,
            lastName: undefined,
            token: undefined,
            userId: undefined,
            userName: undefined,
            roles: [],
          };
          state.status = COMMON_STATUS.UNAUNTHETICATED;
        }
      })
      .addCase(loginAsync.rejected, (state) => {
        state.status = COMMON_STATUS.UNAUNTHETICATED;
      })
      .addCase(invitationSendAsync.pending, (state) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(
        invitationSendAsync.fulfilled,
        (state: SliceState, action: any) => {
          state.value = action.payload;
          state.status = COMMON_STATUS.AUNTHETICATED;
        }
      )
      .addCase(invitationSendAsync.rejected, (state) => {
        state.status = COMMON_STATUS.FAILED;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetLogout, () => {
        return initialState;
      });
  },
});

export const { updateListView, updateLoginStatus } = loginSlice.actions;
export const getToken = (state: RootState) =>
  state.login.value && state.login.value.token ? state.login.value.token : "";
export const getRoles = (state: RootState) =>
  state.login.value && state.login.value.roles ? state.login.value.roles : [];
export const getLoginStatus = (state: RootState) => state.login.status;
export const getUsername = (state: RootState) => state.login.value.userName;
export const getErrorMessage = (state: RootState) => state.login.value.errorMessage;
export const getName = (state: RootState) =>
  state.login.value.firstName + " " + state.login.value.lastName;
export const getUserListView = (state: RootState) =>
  state.login.value && state.login.value.listView != null
    ? state.login.value.listView
    : false;
export default loginSlice.reducer;
